import { useEffect, useState } from "react";

// Isolated so the 1-second tick re-renders only this text, not the surrounding list or page.
export function Countdown({ until, className = "num countdown" }: { until: number; className?: string }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const remaining = Math.max(0, until - now);
  const minutes = String(Math.floor(remaining / 60000)).padStart(2, "0");
  const seconds = String(Math.floor((remaining % 60000) / 1000)).padStart(2, "0");
  return <b className={className}>{minutes}:{seconds}</b>;
}
